import { useEffect } from "react";
import { NewPackageViewModel } from "../../viewmodels/packaging/NewPackageViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import SlideOver from "../../components/slideOver/SlideOver";

import NewPackageForm from "../../components/forms/packaging/NewPackageForm";
import EmptyModal from "../../components/modals/EmptyModal";

function NewPackageScreen(props) {
  const { addSnackbar, logout } = props;
  const {
    getManufacturedItemById,
    emptyModal,
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
    employeeOptions,
    getEmployeesForDropdown,
    getInContactPackagingSupplies,
    savePackagingDetailsAndPrint,
    getBrands,
    brands,
    showErrorModal,
    printingLabelType,
    scaleIsOpen,
    setScaleIsOpen,
    printedPackageItems,
    deleteSinglePackagedItem,
    reprintPackageLabel,
    packagingLabel,
    setPackagingLabel,
    fetchProductByPlu,
    printProgress,
    reprintInProgress,
    deleteInProgress,
    supervisorOptions,
    lotNumbers,
    onSearchLotNumbers,
  } = NewPackageViewModel(logout, addSnackbar);

  useEffect(() => {
    getEmployeesForDropdown(2, [1, 2]);
    getEmployeesForDropdown(1, [1, 2]);
    getBrands();
  }, []);

  function printPackagingLabel(labelDetails) {
    setTimeout(function () {
      window.print();

      if (labelDetails.printCounter < labelDetails.serials.length) {
        const newLabelDetails = {
          ...labelDetails,
          printCounter: labelDetails.printCounter + 1,
        };

        setPackagingLabel(newLabelDetails.serials[labelDetails.printCounter]);

        printPackagingLabel(newLabelDetails);
      }
    }, 1500);
  }

  return (
    <div>
      <div className="hide-for-print mt-2">
        <NewPackageForm
          lotNumbers={lotNumbers}
          employeeOptions={employeeOptions}
          isEdit={false}
          getManufacturedItemById={getManufacturedItemById}
          packagedProduct={null}
          setEmptyModelOpen={setEmptyModelOpen}
          setSlideOver={setSlideOver}
          savePackagingDetailsAndPrint={savePackagingDetailsAndPrint}
          packagingLabel={packagingLabel}
          getInContactPackagingSupplies={getInContactPackagingSupplies}
          setPackagingLabel={setPackagingLabel}
          brands={brands}
          showErrorModal={showErrorModal}
          setScaleIsOpen={setScaleIsOpen}
          scaleIsOpen={scaleIsOpen}
          printedPackageItems={printedPackageItems}
          onSearchLotNumbers={onSearchLotNumbers}
          deleteSinglePackagedItem={deleteSinglePackagedItem}
          reprintPackageLabel={reprintPackageLabel}
          fetchProductByPlu={fetchProductByPlu}
          printProgress={printProgress}
          reprintInProgress={reprintInProgress}
          deleteInProgress={deleteInProgress}
          supervisorOptions={supervisorOptions}
        />
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        customClass={slideOver.size ? slideOver.size : "max-w-7xl"}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NewPackageScreen),
);
